import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * RC-WEB-5 GATE 13 — in-app Back that returns to the ACTUAL previous screen.
 *
 * React Router keeps an `idx` in the history state. When it is greater than 0
 * there is real in-app history, so `navigate(-1)` is correct. Only when the
 * page was opened directly (deep link, push notification, new tab) do we fall
 * back to a sensible feature-level route.
 */
export const useAppBack = (fallback = "/dashboard") => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    const idx = location.state?.idx ?? window.history.state?.idx ?? 0;
    if (idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, location.state, fallback]);
};

export default useAppBack;
